import {ReduxStateType} from '../store';

export const selectBankDetails = (state: ReduxStateType) => {
  return state.bankDetails;
};
